import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prototype2');
import { OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-prototype2',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prototype2/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PagePrototype2Component implements OnInit, OnDestroy {
    @ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement>;
    @ViewChild('canvasElement') canvasElement: ElementRef<HTMLCanvasElement>;

    public isCameraOn: boolean = false;
    public currentEmotion: string = "";
    public behavior: any = null;
    public historyList: any[] = [];
    public activeHistoryQueue: any[] = [];

    public finalState: string = "대기 중...";
    public stateProbability: number = 0.0;
    
    private stream: MediaStream | null = null;
    private captureInterval: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async ngOnDestroy() {
        this.stopCamera();
    }

    public async startCamera() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
            this.videoElement.nativeElement.srcObject = this.stream;
            this.isCameraOn = true;
            
            this.videoElement.nativeElement.onloadedmetadata = () => {
                this.canvasElement.nativeElement.width = 640;
                this.canvasElement.nativeElement.height = 480;
                this.startAnalysis();
            };
            
            await this.service.render();
        } catch (err) {
            console.error(err);
            await this.service.alert.show({ title: '오류', message: '카메라 접근 실패' });
        }
    }

    public async stopCamera() {
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }
        if (this.captureInterval) {
            clearInterval(this.captureInterval);
            this.captureInterval = null;
        }
        
        if (this.videoElement) this.videoElement.nativeElement.srcObject = null;
        if (this.canvasElement) {
            const ctx = this.canvasElement.nativeElement.getContext('2d');
            if (ctx) ctx.clearRect(0, 0, this.canvasElement.nativeElement.width, this.canvasElement.nativeElement.height);
        }
        this.isCameraOn = false;
        this.historyList = [];
        this.activeHistoryQueue = [];
        this.finalState = "대기 중...";
        await this.service.render();
    }

    private startAnalysis() {
        if (this.captureInterval) clearInterval(this.captureInterval);
        
        // 1초 주기로 타임시리즈 데이터 생성
        this.captureInterval = setInterval(() => {
            this.captureAndPredict();
        }, 1000);
    }

    private async captureAndPredict() {
        const video = this.videoElement.nativeElement;
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
        
        try {
            let resultInfo = await wiz.call("predict", { 
                image: dataUrl,
                history: JSON.stringify(this.activeHistoryQueue)
            });
            
            if (resultInfo.code === 200 && resultInfo.data.status === "success") {
                const result = resultInfo.data;
                this.currentEmotion = result.emotion;
                this.behavior = result.behavior;
                this.activeHistoryQueue = result.history;
                this.finalState = result.final_state;
                this.stateProbability = result.state_probability;

                // 로그용
                this.historyList.unshift({
                    time: new Date().toLocaleTimeString(),
                    emotion: this.currentEmotion,
                    state: this.finalState,
                    prob: (this.stateProbability * 100).toFixed(1)
                });

                if (this.historyList.length > 10) {
                    this.historyList.pop();
                }

                this.drawResult(result.region);
            } else if (resultInfo.code === 200 && resultInfo.data.status === "error") {
                // 얼굴이 감지되지 않거나 에러인 경우 실시간 반영
                this.finalState = resultInfo.data.message === "No face detected" ? "얼굴 감지 불가" : "분석 오류";
                this.drawResult(null);
            }
        } catch (e) {
            console.error("Predict Exception:", e);
        }
        await this.service.render();
    }

    private drawResult(region: any) {
        const canvas = this.canvasElement.nativeElement;
        const video = this.videoElement.nativeElement;
        const ctx = canvas.getContext('2d');
        
        // CSS object-cover 등 화면 크기 변경에 실시간 대응하기 위해 내부 픽셀 갱신
        if (canvas.width !== video.clientWidth || canvas.height !== video.clientHeight) {
            canvas.width = video.clientWidth;
            canvas.height = video.clientHeight;
        }
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (region && region.w && region.h) {
            // bounding box 렌더링
            ctx.strokeStyle = '#ef4444'; // red
            ctx.lineWidth = 3;

            // object-cover 속성으로 인해 잘려나가는 영역 보정 계산
            const videoRatio = video.videoWidth / video.videoHeight;
            const containerRatio = canvas.width / canvas.height;
            
            let drawWidth, drawHeight, offsetX = 0, offsetY = 0;
            
            if (containerRatio > videoRatio) {
                // 부모 컨테이너가 더 가로로 길 때 (위아래가 잘림)
                drawWidth = canvas.width;
                drawHeight = canvas.width / videoRatio;
                offsetY = (canvas.height - drawHeight) / 2;
            } else {
                // 부모 컨테이너가 더 세로로 길 때 (좌우가 잘림)
                drawHeight = canvas.height;
                drawWidth = canvas.height * videoRatio;
                offsetX = (canvas.width - drawWidth) / 2;
            }
            
            const scaleX = drawWidth / video.videoWidth;
            const scaleY = drawHeight / video.videoHeight;
            
            const rx = (region.x * scaleX) + offsetX;
            const ry = (region.y * scaleY) + offsetY;
            const rw = region.w * scaleX;
            const rh = region.h * scaleY;
            
            ctx.strokeRect(rx, ry, rw, rh);
            
            // 상태 텍스트
            ctx.fillStyle = '#ef4444';
            ctx.font = 'bold 24px sans-serif';
            ctx.fillText(`State: ${this.finalState}`, rx, ry - 10);
        }
    }
}

export default PagePrototype2Component;